/** The platform's pages, in sidebar order, with their shortcut keys (press g, then the key). */
import type { IconName } from "./icons.ts";

export interface Page {
  key: string;
  href: string;
  label: string;
  icon: IconName;
  /** Second key after "g" */
  go: string;
  group: "Work" | "Clients" | "Library";
  /** Words that also find the page in the command palette */
  also?: string;
}

export const PAGES: Page[] = [
  { key: "today", href: "#/", label: "Today", icon: "today", go: "t", group: "Work", also: "home dashboard due" },
  { key: "leads", href: "#/leads", label: "Leads", icon: "leads", go: "l", group: "Work", also: "enquiries prospects crm contacts" },
  { key: "pipeline", href: "#/pipeline", label: "Pipeline", icon: "pipeline", go: "p", group: "Work", also: "plan numbers funnel sales" },
  { key: "timeline", href: "#/timeline", label: "Timeline", icon: "timeline", go: "m", group: "Work", also: "milestones pace base case optimistic forecast projection goals targets growth" },
  { key: "insights", href: "#/insights", label: "Insights", icon: "chart", go: "i", group: "Work", also: "reports promises on time reply time turnaround funnel conversion review" },
  { key: "partners", href: "#/partners", label: "Partners", icon: "partners", go: "r", group: "Work", also: "referrals introductions" },
  { key: "audits", href: "#/audits", label: "Audits", icon: "audits", go: "a", group: "Clients", also: "clients reports implementation" },
  { key: "reference", href: "#/reference", label: "Rate cards", icon: "reference", go: "c", group: "Library", also: "packaging carriers boxes catalogue prices" },
  { key: "tools", href: "#/tools", label: "Tools", icon: "tools", go: "o", group: "Library", also: "calculators volumetric katana air box pallet returns" },
  { key: "documents", href: "#/documents", label: "Documents", icon: "documents", go: "d", group: "Library", also: "policies plan register pandadoc" },
  { key: "activity", href: "#/activity", label: "Activity", icon: "history", go: "h", group: "Library", also: "audit trail history log deleted changes who changed" },
  { key: "settings", href: "#/settings", label: "Settings", icon: "settings", go: "s", group: "Library", also: "preferences theme dark mode appearance profile shortcuts" },
];

/** Which page a hash belongs to (a lead page belongs to Leads, an audit page to Audits). */
export function pageFor(hash: string): Page {
  const h = hash || "#/";
  const byKey = (k: string) => PAGES.find((p) => p.key === k)!;
  if (h.startsWith("#/lead")) return byKey("leads");
  if (h.startsWith("#/audit")) return byKey("audits");
  return PAGES.find((p) => p.href !== "#/" && h.startsWith(p.href)) ?? PAGES[0]!;
}
